import React from "react";
import TopRatedRides from "../components/discoverourcabs";

const SERVICE_CONTENT = {
  airport: {
    heading: "Airport Transfer Vehicles",
    subtitle: "Choose from Plus Cabs airport transfer vehicles with clear fares, luggage capacity, and quick booking.",
  },
  outstation: {
    heading: "Outstation Vehicles",
    subtitle: "Browse comfortable outstation cabs for one-way and round-trip travel with per-kilometer pricing.",
  },
  local: {
    heading: "Local Package Vehicles",
    subtitle: "Select hourly city packages for meetings, sightseeing, errands, and local travel.",
  },
};

export default function ServiceVehiclesPage({ tripType }) {
  const content = SERVICE_CONTENT[tripType] || SERVICE_CONTENT.airport;

  return (
    <TopRatedRides
      initialTrip={tripType}
      lockTrip
      heading={content.heading}
      subtitle={content.subtitle}
    />
  );
}
